import React from 'react';
import './AdminMenu.scss'

export default function AdminMenu(props) {

    return (
        <div className="admin-menu-wrapper">
            <ul>
                <li className={props.selected === "userlist" ? "selected" : ""}><a href="/admin/userlist">User List</a></li>
                <li className={props.selected === "momreport" ? "selected" : ""}><a href="/admin/momreport">MOM Report</a></li>
                <li className={props.selected === "announcement" ? "selected" : ""}><a href="/admin/announcement">Announcements</a></li>
                {props.adminGroup === 'Admin' ? <li className={props.selected === "dailyPaymentTransaction" ? "selected" : ""}><a href="/admin/daily-payment-transaction">Daily Payment Transaction</a></li> : null}
                {props.adminGroup === 'Admin' ? <li className={props.selected === "evaluation-summary" ? "selected" : ""}><a href="/admin/evaluation-summary">User Evaluation Report</a></li> : null}
                {props.adminGroup === 'Admin' ? <li className={props.selected === "settings" ? "selected" : ""}><a href="/admin/settings">Settings</a></li> : null}
                <li className={props.selected === "audit" ? "selected" : ""}><a href="/admin/audit">Audit Log</a></li>
            </ul>
        </div>
    )
}